import { NgIf } from '@angular/common';
import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';

import { MatFormField, MatLabel, MatPrefix, MatError } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { AgrNumberDirective } from '@next/core-lib/form';
import { Currency, CurrencySymbolPipe, TranslatePipe } from '@next/core-lib/i18n';

import { CostItemForm } from './cost-item.model';

@Component({
  selector: 'app-cost-item',
  templateUrl: 'cost-item.component.html',
  imports: [
    ReactiveFormsModule,
    MatFormField,
    MatLabel,
    MatPrefix,
    MatInput,
    AgrNumberDirective,
    NgIf,
    MatError,
    CurrencySymbolPipe,
    TranslatePipe,
  ],
})
export class CostItemComponent implements OnInit, OnChanges {
  @Input() form: FormGroup<CostItemForm>;
  @Input() currency: Currency;
  @Input() vatPercentage?: number;
  @Input() amountOfChicks?: number;

  @Input() chickCostLabel = '';

  @Input() chickCostInvalid = false;
  @Input() chicksTotalCostInvalid = false;

  ngOnInit(): void {
    this.calculateAmountsBasedOnPricePerChick();
  }

  ngOnChanges(): void {
    this.calculateAmountsBasedOnPricePerChick();
  }

  chickCostChange(): void {
    this.calculateAmountsBasedOnPricePerChick();
  }

  chickTotalCostChange(): void {
    this.calculateAmountsBasedOnTotalAmount();
  }

  chicksTotalCostIncludingVatChange(): void {
    this.calculateAmountsBasedOnTotalAmountIncludingVAT();
  }

  calculateAmountsBasedOnPricePerChick() {
    let amountExcludingVat = null;
    let amountIncludingVat = null;
    const chickCost = this.form.controls.chickCost.value;

    if (this.amountOfChicks != null && chickCost != null) {
      amountExcludingVat = chickCost * this.amountOfChicks;
    }

    if (amountExcludingVat != null) {
      amountIncludingVat = (this.vatPercentage / 100) * amountExcludingVat + amountExcludingVat;
    }

    this.form.controls.chicksTotalCost.patchValue(amountExcludingVat);
    this.form.controls.chicksTotalCostIncludingVat.patchValue(amountIncludingVat);
  }

  calculateAmountsBasedOnTotalAmount() {
    let pricePerChick = null;
    let chicksTotalCostIncludingVat = null;
    const chicksTotalCost = this.form.controls.chicksTotalCost.value;

    if (this.amountOfChicks != null && chicksTotalCost != null) {
      pricePerChick = chicksTotalCost / this.amountOfChicks;
    }

    if (pricePerChick != null) {
      chicksTotalCostIncludingVat = (this.vatPercentage / 100) * chicksTotalCost + chicksTotalCost;
    }

    this.form.controls.chickCost.patchValue(pricePerChick);
    this.form.controls.chicksTotalCostIncludingVat.patchValue(chicksTotalCostIncludingVat);
  }

  calculateAmountsBasedOnTotalAmountIncludingVAT() {
    let pricePerChick = null;
    let chicksTotalCost = null;
    const chicksTotalCostIncludingVat = this.form.controls.chicksTotalCostIncludingVat.value;

    if (this.amountOfChicks != null && chicksTotalCostIncludingVat != null) {
      chicksTotalCost = (chicksTotalCostIncludingVat * 100) / (100 + this.vatPercentage);
      pricePerChick = chicksTotalCost / this.amountOfChicks;
    }

    this.form.controls.chickCost.patchValue(pricePerChick);
    this.form.controls.chicksTotalCost.patchValue(chicksTotalCost);
  }
}
